import getDefaultSMSProvider from './get-default-sms-provider'

const getters = {
  getDefaultSMSProvider,
}

export default getters
